import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search, Building2, MapPin, ArrowRight } from "lucide-react";
import { Input } from "../../components/ui/input";
import { api } from "../../lib/api";

export default function Hospitals() {
  const [list, setList] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const refresh = (term = "") => {
    setLoading(true);
    api.get("/patient/hospitals", { params: term ? { q: term } : {} })
      .then((r) => setList(r.data))
      .finally(() => setLoading(false));
  };
  useEffect(() => { refresh(); }, []);

  return (
    <div className="space-y-6" data-testid="hospitals-page">
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-teal-400">◖ find a doctor</div>
        <h1 className="mt-2 text-3xl sm:text-4xl tracking-tight font-light">Browse hospitals</h1>
      </div>

      <form onSubmit={(e) => { e.preventDefault(); refresh(q); }} className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-mb-fg2" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} data-testid="hospital-search"
          placeholder="Search hospitals by name"
          className="pl-9 bg-mb-surface2 border-mb-border text-white h-11 rounded-lg focus-visible:ring-teal-500" />
      </form>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {loading && <div className="text-sm text-mb-fg2">Loading…</div>}
        {!loading && list.length === 0 && (
          <div className="text-sm text-mb-fg2" data-testid="hospitals-empty">No hospitals found.</div>
        )}
        {list.map((h) => (
          <Link key={h.id} to={`/patient/hospitals/${h.id}`}
            data-testid={`hospital-card-${h.id}`}
            className="group rounded-xl border border-mb-border bg-mb-surface p-6 hover:border-teal-500/30 transition-colors block">
            <div className="flex items-center gap-3">
              <div className="h-10 w-10 rounded-lg bg-teal-500/10 text-teal-300 flex items-center justify-center">
                <Building2 className="h-5 w-5" />
              </div>
              <div className="min-w-0">
                <div className="text-base text-white truncate">{h.name}</div>
                <div className="text-xs text-mb-fg2 uppercase tracking-[0.2em] truncate">{h.slug}</div>
              </div>
            </div>
            {h.address && (
              <div className="mt-4 text-sm text-mb-fg2 flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 text-mb-fg2" /> <span className="line-clamp-2">{h.address}</span>
              </div>
            )}
            <div className="mt-6 text-sm text-teal-400 inline-flex items-center gap-2">
              View doctors <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
